import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IProductVariationMap) {
    (function(IEntry) {
        (function(VariationDisplayType) {
            VariationDisplayType["VARIATION_DISPLAY_TYPE_UNKNOWN"] = "VARIATION_DISPLAY_TYPE_UNKNOWN";
            /**
       * one variation option available
       */ VariationDisplayType["SINGLE"] = "SINGLE";
            /**
       * allOptionsHaveSwatches
       */ VariationDisplayType["SWATCH"] = "SWATCH";
            /**
       * All options are less than or equal to 11 characters
       */ VariationDisplayType["SHORT"] = "SHORT";
            /**
       * All options are longer than 11 characters and there are fewer than 6 options
       * Deprecated, defaults to DROPDOWN
       * @deprecated
       */ VariationDisplayType["LONG"] = "LONG";
            /**
       * default
       */ VariationDisplayType["DROPDOWN"] = "DROPDOWN";
        })(IEntry.VariationDisplayType || (IEntry.VariationDisplayType = {}));
        (function(IValue) {
            IValue.build = function(partial) {
                return _object_spread({
                    translation_overrides: []
                }, partial !== null && partial !== void 0 ? partial : {});
            };
        })(IEntry.IValue || (IEntry.IValue = {}));
        IEntry.build = function(partial) {
            return _object_spread({
                values: [],
                entry_values: [],
                translation_overrides: []
            }, partial !== null && partial !== void 0 ? partial : {});
        };
    })(IProductVariationMap.IEntry || (IProductVariationMap.IEntry = {}));
    IProductVariationMap.build = function(partial) {
        return _object_spread({
            entries: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IProductVariationMap || (IProductVariationMap = {}));
export var IProductVariationMap;
